import React, { useEffect } from 'react';
import './Header.css';

function Header({ onJoinWaitlist }) {
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('header');
      if (window.scrollY > 50) {
        header.style.background = 'rgba(10, 14, 39, 0.95)';
        header.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.3)';
      } else {
        header.style.background = 'rgba(10, 14, 39, 0.6)';
        header.style.boxShadow = 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const target = document.querySelector(sectionId);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <header>
      <div className="logo-container">
        <img src="/PNG-02.png" alt="Talkbooks Logo" />
      </div>
      <nav>
        <a href="#features" onClick={(e) => scrollToSection(e, '#features')}>Features</a>
        <a href="#languages" onClick={(e) => scrollToSection(e, '#languages')}>Languages</a>
        <a href="#about" onClick={(e) => scrollToSection(e, '#about')}>About</a>
        <a href="#contact" onClick={(e) => scrollToSection(e, '#contact')}>Contact</a>
      </nav>
      <button className="cta-button" onClick={onJoinWaitlist}>Join Waitlist</button>
    </header>
  );
}

export default Header;

